<template>
  <div class="i-scarcity-strip">
    We run <strong>48 sessions</strong> each week. This week: <strong>11 slots remaining.</strong>
    First-come, first-served.
    <a
      href="#book"
      class="scarcity-strip__book"
      >Book now →</a
    >
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.i-scarcity-strip {
  background: var(--purple-pale);
  border-bottom: 1px solid var(--border);
  padding: 9px 24px;
  text-align: center;
  font-size: 0.78rem;
  color: var(--muted);
  font-weight: 500;
  letter-spacing: 0.01em;

  strong {
    color: var(--text);
    font-weight: 700;
  }

  &__book {
    color: var(--purple);
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 2px;
    margin-left: 4px;

    &:hover {
      color: var(--purple-lt);
    }
  }
}
</style>
